export default {
  navigationBarTitleText: '资料下载',
};
